import { ref } from 'vue';
import useVuelidate from '@vuelidate/core';

export const useValidation = () => {
  const errors = ref(null);

  let $v = useVuelidate();

  // eslint-disable-next-line
  // @ts-ignore
  const defineValidation = (rules, payload) => {
    $v = useVuelidate(rules, payload);
    return $v;
  };

  const fieldStyles = (key: string, styles?: string): string => {
    const validation =
      ($v.value[key].$invalid && $v.value[key].$dirty) || (errors.value && errors.value[key]) ? 'p-invalid' : '';
    return `${styles} ${validation}`;
  };

  const anyDirty = () => $v.value.$anyDirty;

  const resetDirty = () => $v.value.$reset();

  return {
    errors,
    $v,
    defineValidation,
    fieldStyles,
    anyDirty,
    resetDirty,
  };
};
